module.exports = new __parcel__URL__("sound_effects_button_active.1a70b5c7.png").toString();